import api from "../../api/api";

export const ACTION_SET_CONNECTED = "ACTION_SET_CONNECTED";
export function setConnected(payload) {
    return {
        type: ACTION_SET_CONNECTED,
        payload,
    };
}
export const ACTION_SET_USER = "ACTION_SET_USER";

export function setUser(account) {
    return function (dispatch) {
        if (account) {
            api.get("user/" + account).then((resp) => {
                if (resp.data === "create") {
                    let user = { account };
                    dispatch(saveUser(user));
                } else {
                    dispatch({
                        type: ACTION_SET_USER,
                        payload: resp.data,
                    });
                }
            });
        }
    };
}

export const ACTION_UNSET_USER = "ACTION_UNSET_USER";

export const ACTION_CREATE_USER = "ACTION_CREATE_USER";
export const ACTION_UPDATE_USER = "ACTION_UPDATE_USER";

export function saveUser(changes) {
    return function (dispatch) {
        if (changes._id) {
            api.put("user/" + changes._id, changes).then((resp) => {
                dispatch({
                    type: ACTION_UPDATE_USER,
                    payload: resp.data,
                });
            });
        } else {
            api.post("user/addUser", changes).then((resp) =>
                dispatch({
                    type: ACTION_CREATE_USER,
                    payload: resp.data,
                })
            );
        }
    };
}
export function uploadAvatar(id, file) {
    return function (dispatch) {
        try {
            const formData = new FormData();
            formData.append("file", file);
            api.post("userAvatar/" + id, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            }).then((res) => {
                dispatch(saveUser(res.data));
            });
        } catch (error) {
            console.log(error);
        }
    };
}

// Admin functional ============================= //

export const ACTION_SET_USERS = "ACTION_SET_USERS";
export function setUsers() {
    return function (dispatch) {
        try {
            api.get("user/").then((resp) => {
                dispatch({ type: ACTION_SET_USERS, payload: resp.data });
            });
        } catch (error) {
            console.log(error);
        }
    };
}

export const ACTION_DELETE_USER = "ACTION_DELETE_USER";
export function deleteWaiter(id) {
    return function (dispatch) {
        api.delete("users/" + id).then((resp) =>
            dispatch({
                type: ACTION_DELETE_USER,
                payload: resp.data,
            })
        );
    };
}
